module.exports = __webpack_public_path__ + "img/force_distribution.4beac5ab.jpg";